import { render, staticRenderFns } from "./MessageContentImage.vue?vue&type=template&id=0d81a04e&scoped=true&"
import script from "./MessageContentImage.vue?vue&type=script&lang=js&"
export * from "./MessageContentImage.vue?vue&type=script&lang=js&"
import style0 from "../../style/message-box.scss?vue&type=style&index=0&id=0d81a04e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d81a04e",
  null
  
)

export default component.exports